import React from 'react';
import PropTypes from 'prop-types';
export var Component = function Component(_ref) {
  var children = _ref.children,
      htmlString = _ref.htmlString;
  return children ? React.createElement("div", null, React.createElement("div", {
    className: "html-container",
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  }), children) : React.createElement("div", {
    className: "html-container",
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  });
};
Component.displayName = 'HTML';
Component.defaultProps = {
  htmlString: '',
  children: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  htmlString: PropTypes.string
} : {};